import iframeResize from '@iframe-resizer/parent';

function initEnDonate() {
	const iframes = document.querySelectorAll( '.en-donate iframe' );

	if ( iframes.length ) {
		iframeResize( {
			license: 'GPLv3',
			offsetHeight: 50,
		}, [ ...iframes ] );
	}
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initEnDonate );
} else {
	initEnDonate();
}
